import { Link } from "react-router-dom";

export default function ModuleCard({ module: m, compact = false }) {
  return (
    <div
      data-testid={`module-card-${m.slug}`}
      className="group bg-[#F8F7F4] hard-border p-6 sm:p-8 flex flex-col gap-6 transition-colors duration-200 hover:bg-[#E8F0EB]"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="font-mono text-xs tracking-[0.22em] text-[#8A9992]">{m.index}</span>
        </div>
        <Link
          to={`/modules#${m.slug}`}
          className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#8B2B3A] opacity-0 group-hover:opacity-100 transition-opacity"
          data-testid={`module-card-${m.slug}-learn-more`}
        >
          Read →
        </Link>
      </div>
      <div>
        <h3 className="font-display text-2xl sm:text-3xl leading-tight text-[#0A140F]">{m.name}</h3>
        <p className="mt-3 text-[#4A5A52] text-[15px] leading-relaxed">{m.tagline}</p>
      </div>
      {!compact && (
        <p className="text-sm text-[#4A5A52] leading-relaxed">{m.description}</p>
      )}
      <div className="mt-auto grid grid-cols-3 gap-4 border-t border-[#D6D2C4] pt-5">
        {m.stats.map((s, i) => (
          <div key={i}>
            <div className="mono-label text-[#8A9992] leading-none">{s.label}</div>
            <div className="mt-2 font-mono text-lg sm:text-xl text-[#0A140F] font-semibold">{s.value}</div>
            <div className="font-mono text-[10px] tracking-wider text-[#8B2B3A] mt-0.5">{s.delta}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
